import baseScmService from 'services/baseScmService';

const academyModuleService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchAcademyModule: build.query({
      query: ({ category, keyword }) => ({
        method: 'GET',
        url: '/academy-modules/search/',
        params: { 'filter[category]': category, q: keyword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchAcademyModuleQuery } = academyModuleService;

export default academyModuleService;
